/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataViews } from '../models/data-views';

@Injectable({ providedIn: 'root' })
export class RequestControllerService extends DataBaseService {

  /**
   * Path part for operation requestControllerCanAccessRequest
   */
  static readonly RequestControllerCanAccessRequestPath = '/v1/requests/{entity}/{id}/{mode}';

  /**
   * Get the implicit view thats belongs to the request if the user can access it.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canAccessRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  canAccessRequest$Response(params: {
    entity: string;
    id: string;
    mode: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataViews>> {

    const rb = new RequestBuilder(this.rootUrl, RequestControllerService.RequestControllerCanAccessRequestPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.path('mode', params.mode, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataViews>;
      })
    );
  }
  /**
   * Get the implicit view thats belongs to the request if the user can access it.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `canAccessRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canAccessRequest(params: {
    entity: string;
    id: string;
    mode: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataViews> {

    return this.canAccessRequest$Response(params).pipe(
      map((r: StrictHttpResponse<DataViews>) => r.body as DataViews)
    );
  }

}
